import axiosWrapper from './axiosWrapper'

const URL_MARCA = `api/articulo/marcas`

const getListadoMarcas = (axiosParams) => {
  const url = `${axiosParams.baseURL}/${URL_MARCA}`
  return axiosWrapper.get({ ...axiosParams, url })
}

const serviceArticulo = {
  getListadoMarcas
}

export default serviceArticulo
